module.exports = __webpack_public_path__ + "static/media/case-study-2.5aa84517.jpg";